import { Component, Input, OnInit } from '@angular/core';
import { SubForma } from '@app/shared';
import { LocalDataSource } from 'ng2-smart-table';
import { DocumentConfig } from './shared/document.config.service';
import { Documental, DocumentDataService } from './shared/document.data.service';

@Component({
  selector: 'iw-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
  providers: [DocumentDataService]
})
export class DocumentsComponent implements OnInit {
    //contiene la configuración de la tabla de documentos
    settings = {};
    // contiene los datos de la tabla
    source: LocalDataSource;
    //Datos para llenar la tabla
    table: any[] = [];
    //tipos documentales disponibles
    typeDocumentaryList: Documental[] = [];
    //forma actual
    @Input() form: SubForma;

  constructor(private dds: DocumentDataService) { }

  ngOnInit() {
    //configuración inicial de la tabla
    const configTable = new DocumentConfig();
    this.settings = configTable.settings;
    //suscripción a los eventos realizados en la tabla
    configTable.accion.subscribe((res: any) => {
      this.defineActionFunction(res.action, res.row);
    });
    this.getTypeDocumentary();
    console.log(this.form);
  }

  getTypeDocumentary() {
    this.dds.getTypeDocumentary().subscribe(async (response) => {
      if(response){
        this.typeDocumentaryList = await response; 
        this.fillDataTable();
      }
    });
  }

  fillDataTable(){
    if(this.form && this.form.control_documentos && this.form.control_documentos.length){

      let exists: boolean;
      let data = {};
      this.typeDocumentaryList.forEach(item=>{
        exists = false;
        this.form.control_documentos.forEach((a: any)=>{
          if(item.id == a){
            exists = true;
          }
        })
        if(exists){
          data = {
            serie_id: item.subserie.serie.id,
            serie: item.subserie.serie.nombre,
            subserie_id: item.subserie.id,
            subserie: item.subserie.nombre,
            tipo_documental_id: item.id,
            tipo_documental: item.nombre,
            associate: 'Sí',
            funtions: 'NoFuntions'
          };
        }else{
          data = {
            serie_id: item.subserie.serie.id,
            serie: item.subserie.serie.nombre,
            subserie_id: item.subserie.id,
            subserie: item.subserie.nombre,
            tipo_documental_id: item.id,
            tipo_documental: item.nombre,
            associate: 'No',
          };
        }
        this.table.push(data);
      })
    }else{
      this.typeDocumentaryList.forEach(item=>{
        let data = {
          serie_id: item.subserie.serie.id,
          serie: item.subserie.serie.nombre,
          subserie_id: item.subserie.id,
          subserie: item.subserie.nombre,
          tipo_documental_id: item.id,
          tipo_documental: item.nombre,
          associate: 'No'
        };
        this.table.push(data);
      })
    }
    this.source = new LocalDataSource(this.table);
  }
  
  defineActionFunction(action: "asociar" | "eliminar", data?: any){
    switch(action){
      case 'asociar':
        this.associate(data)
        break;
      case 'eliminar':
        this.delete(data);
        break;
    }
  }

  associate(data: any){
    this.table.forEach(t=>{
      if(t.tipo_documental_id == data.tipo_documental_id){
        this.form['control_documentos'].push(t.tipo_documental_id);
        t['associate'] = 'Sí'
        t['funtions'] = 'NoFuntions'
      }
    });
    this.source.refresh();
  }

  delete(data: any){
    this.table.forEach(t=>{
      if(t.tipo_documental_id ==  data.tipo_documental_id){
        t['associate'] = 'No';
      }
    })
    let index = this.form.control_documentos.indexOf(data.tipo_documental_id);
    this.form.control_documentos.splice(index, 1);
    this.source.refresh();
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/documents/documents.component.ts